<template>
  <Modal
    :title="title"
    :closable="false"
    v-model="modalShowHide"
    :width="width+'px'"
    class="modal-setting"
    footer-hide
    class-name="vertical-center-modal"
  >
    <div class="bg-white">
      <div style="height: 690px;margin: 2px;width: 1160px" class="border m-2 p-10">

        <div class="w-full m-b-5">
          <Tag v-for="(item,index) in pages"
               type="dot"
               class="m-b-5"
               :color="selectedPageId === item.id? 'primary':'default'"
               @click.native="changePage(item.id)"
          >
            {{ item.label }}
          </Tag>
        </div>
        <div class="flex flex-wrap w-full">
          <!--          <Select v-model="selectedPageId" style="width:150px" placeholder="素材类型"-->
          <!--                  class="m-r-15"-->
          <!--                  @on-change="onSelectedPageChange"-->
          <!--          >-->
          <!--            <Option v-for="item in pages" :value="item.id" :key="item.id">{{-->
          <!--                item.label-->
          <!--              }}-->
          <!--            </Option>-->
          <!--          </Select>-->

          <Select style="width:150px" placeholder="分类"
                  class="m-r-15"
                  v-if="hasClass"
                  clearable
                  v-model="selectedObj.selectedClass"
                  @on-change="onSelectedClassChange"
          >
            <Option v-for="item in classList" :value="item.id" :key="item.id">{{
                item.label
              }}
            </Option>
          </Select>

          <Select style="width:150px" placeholder="分组"
                  class="m-r-15 "
                  v-if="hasGroup"
                  clearable
                  v-model="selectedObj.selectedGroup"
                  :value="selectedObj.selectedGroupName"
                  @on-change="onSelectedGroupChange"
          >
            <Option v-for="item in groupList" :value="item.id" :key="item.id">{{
                item.label
              }}
            </Option>
          </Select>

          <!--          <div style="width: 330px;height: 100%" v-if="hasGroup">-->
          <!--            <class2d-group-widget-->
          <!--              ref="classChooseWidget"-->
          <!--              v-if="hasGroup"-->
          <!--              class="w-r-10"-->
          <!--              :gutter="8" :srcType="srcType" @dataChange="onClassGroupChange"-->
          <!--              style="width: 300px;">-->

          <!--            </class2d-group-widget>-->
          <!--          </div>-->


          <Input placeholder="" style="width: 315px;margin-right: 200px" icon="ios-search"
                 v-if="canSearch"
                 v-model="searchText"
                 @on-click="search"
                 @on-enter="search"
          />

          <!--分类/分组/(产品)链接-->
          <div style="width: 200px" v-if="hasProductChoose">
            <Input placeholder="选择商品" style="background-color: white;width: 200px"
                   readonly clearable
                   v-model="selectedObj.selectedProductName"
                   @on-change="onProductSelectedChange"
            >
               <span style="cursor:pointer" slot="append"
                     @click="showprochoose=true">
                <i class="icon-link"/>
              </span>
            </Input>
          </div>
          <!--          占位-->
          <div v-if="!canSearch" style="width: 315px;margin-right: 200px"></div>
          <!--          分类分组的链接-->
          <div v-if="hasGroup"
               @click.stop="changeCheckBoxStatus"
               class="flex flex-wrap j-center a-center"
               :style="{marginTop:getMarginTop()}"
               style="border: 1px solid #DEDEDE; border-radius: 3px;height: 33px;margin-right: 15px;cursor: pointer">

            <Checkbox v-model="checkboxStatus"
                      @on-change="checkboxStatusChange"
                      class="m-l-10 m-r-5"
            ></Checkbox>

            <span class=" p-5 p-l-10 p-r-10  w-140"
                  style="min-width:150px;height:33px;border-width: 1px;
                border-right: 1px solid #DEDEDE;
                display: inline-block;vertical-align: middle;text-align: center">
            {{ getClass2dGroupLabel }}
          </span>
            <span class="p-5 p-h-10  lin1"
                  v-if="hasGroup"
                  style="height: 33px;width: 330px;display: inline-block;vertical-align: middle">
            {{ getClass2dGroupUrl }}
          </span>
            <Tooltip content="复制"
                     v-if="hasGroup"
            >
              <div class=" icon-copy fs-18 p-5 bg-white"
                   style="height:28px;color: #1472FF;cursor: pointer;border-left: 1px solid #DEDEDE"
                   v-clipboard:copy=" getClass2dGroupUrl"
                   v-clipboard:error="copyOnError"
                   v-clipboard:success="copy"/>
            </Tooltip>
          </div>
        </div>

        <Table v-if="dataType === 0" :columns="columns" :data="dataList" class="m-t-10"
               @on-row-click="onRowClick"
               :height="getTableHeight()">

          <template v-slot:selection="{row,index}">
            <div class="relative">
              <!--              <img @click="preview(row)" class="w-40 h-40 p-8" style="cursor: pointer;"-->
              <!--                   src="../../../assets/common/ic-preview@2x.png">-->
              <Checkbox :value="isSelected(row)"></Checkbox>
              <!--              禁止checkbox点击-->
              <div class="w-full h-full absolute" @click.stop="onRowClick(row)" style="top: 0;left: -2px;z-index: 999"></div>
            </div>
          </template>
          <!--            预览图标-->
          <template v-slot:preview="{row,index}">
            <div class="flex a-center j-center">
              <img @click="preview(row)" class="w-40 h-40 p-8" style="cursor: pointer;"
                   src="../../../assets/common/ic-preview@2x.png">
            </div>
          </template>

          <template v-slot:imageUrl="{row,index}">
            <img src="../../../assets/common/ic_default_img.png" class="w-40 h-30"/>
          </template>

          <template v-slot:link="{row,index}">
            <div class="flex a-center">
              <!--              <div class="flex-1 text-left">-->
              <!--                {{ row.url }}-->
              <!--              </div>-->
              <Tooltip content="复制">
                <i class=" m-h-15 icon-copy fs-20" style="color: #1472FF;cursor: pointer"
                   v-clipboard:copy="copytext"
                   v-clipboard:error="copyOnError"
                   v-clipboard:success="copy"/>
              </Tooltip>
            </div>
          </template>

          <template v-slot:copy="{row,index}">
            <Tooltip content="复制">
              <div class="flex a-center">
                <div class=" icon-copy fs-20 m-l-5" style="color: #1472FF;cursor: pointer;"
                     v-clipboard:copy="row.url"
                     v-clipboard:error="copyOnError"
                     v-clipboard:success="copy"/>
              </div>
            </Tooltip>
          </template>

          <!--            播放图标-->
          <template v-slot:play="{row,index}">
            <div class="flex a-center j-center">
              <img @click="play(row)" class="w-40 h-40 p-8" style="cursor: pointer;"
                   src="../../../assets/common/play-square@2x.png">
            </div>
          </template>

          <template v-slot:content="{row,index}">
            <div class="flex a-center">
              <img src="../../../assets/common/ic_default_img.png"
                   class="w-40 h-30 flex-shrink-0 m-v-15"/>
              <tooltip max-width="300"
                       content="案例内容案例内容案内容案例内案例例内案例内容案例内案例内容案例内容案内容案例内案例例内案例内容案例内容案例内容案内容案例内案例例内案例内容案例内">
                <div class="m-l-10 lin1" style="text-align: left">
                  案例内容案例内容案内容案例内案例例内案例内容案例内案例内容案例内容案内容案例内案例例内案例内容案例内容案例内容案内容案例内案例例内案例内容案例内
                </div>
              </tooltip>
            </div>
          </template>

          <template v-slot:playbillContent="{row,index}">
            <div class="flex a-center">
              <img src="../../../assets/common/ic_default_img.png"
                   class="w-40 h-30 flex-shrink-0 m-v-15"/>
              <tooltip max-width="300"
                       content="海报内容海报内容海报内容海报内容海报内容海报内容海报内容海报内容海报内容海报内容">
                <div class="m-l-10 lin1" style="text-align: left">
                  海报内容海报内容海报内容海报内容海报内容海报内容海报内容海报内容海报内容海报内容海报内容
                </div>
              </tooltip>
            </div>
          </template>

          <template v-slot:status="{row,index}">
            <div class="flex a-center j-center">
              <div class="p-h-10 fs-13 flex a-center j-center p-t-2"
                   style="background-color: #EEFFEF;color: #4CAF50;border-radius: 11px;"
                   v-if="row.status === 1">
                已发布
              </div>
              <div class="p-h-10 fs-13 flex a-center j-center p-t-2"
                   style="background-color: #FFF3EB;color: red;border-radius: 11px;"
                   v-else>
                未发布
              </div>
            </div>
          </template>


        </Table>

        <div v-if="dataType === 1" class="w-full" style="height: 550px">
          <div class="flex p-b-25" style="flex-wrap: wrap">
            <div
              style="height: 60px;margin-right: 30px;background-color: white"
              :key="index"
              :class="{'m-l-100':index % 5===0 && index %15 !==0}"
              class="flex a-center j-center m-t-10"
              v-for="(item,index) in dataList"
              v-clipboard:copy="item.url"
              v-clipboard:error="copyOnError"
              v-clipboard:success="copy">
              <img :src="item.url" alt="" style="width:30px;"/>
              <!--                      <div style="width: 50px;height: 50px;background-color: red">sss</div>-->
            </div>
          </div>
        </div>

        <div v-if="dataType === 2" class=" scrollbar  o-y-auto  p-t-10"
             style="height: 500px"
        >
          <div
            class="list-container"
            style="width:100%;top: 60px;overflow: hidden">
            <div :class="{
                   'item-selected':isSelected(item),'item-normal':!isSelected(item),
                   'm-r-20':index %7!==6
                 }" :key="index"
                 @click="onRowClick(item,index)"
                 class=" m-b-10 item b-2 bg-white"
                 v-for="(item,index) in dataList">
              <div class="w-full h-full">
                <div class="w-full h-120"
                     style="position: relative;background-color: rgb(249, 249, 249)">
                  <img
                    :src="(!item.imgUrl)?require('../../../assets/common/ic_wutu@2x.png'):item.imgUrl"
                    style="width: 100%;height: 120px;object-fit: cover"/>
                  <!--鼠标悬停编辑-->
                  <div class="flex a-end j-center  w-full h-full  item-editable"
                       style="position: absolute;bottom: 0;left: 0;right: 0;height: 30px;background-color: #0000004d">
                    <div @click.stop=""
                         class="w-24 h-24 b-round flex a-center j-center"
                         style="cursor: pointer;">
                      <img class="w-20 h-20" src="../../../assets/common/ic-preview@2x.png"
                           @click="preview(item)"
                      />
                    </div>
                    <!--<div @click.stop="itemDelete(item,index)"-->
                    <!--class="w-24 h-24 b-round flex a-center j-center m-l-25"-->
                    <!--style="cursor: pointer;">-->
                    <!--<img class="w-20 h-20" src="../../../assets/common/ic-delete@2x.png"/>-->
                    <!--</div>-->
                  </div>
                  <!--鼠标悬停三角-->
                  <div class="triangle" style="position: absolute;top: 0;right: 0;"
                       v-if="isSelected(item)">
                  </div>
                  <!--鼠标悬停对号-->
                  <img class="w-16 h-16" src="../../../assets/common/ic-right@2x.png"
                       style="position: absolute;top: 0;right: 0;"
                       v-if="isSelected(item)">
                </div>
                <div class="m-h-5 m-t-12 lin1" style="width: unset">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>

        <div style="height: 60px;">
<!--          首页没有-->
          <Page :current="tablePage.currentPage" :page-size="tablePage.pageSize"
                :total="tablePage.total" show-elevator
                @on-change="onPageChange"
                v-if="selectedPageId !== 9"
                show-total class="m-t-10 p-b-10"/>
        </div>


      </div>
      <div class="w-full flex j-center p-v-10" slot="footer">
        <Button @click="cancel()" style="width: 100px" v-if="hasCancel">取消</Button>
        <Button @click="ok()" style="margin-left: 50px;width: 100px" type="primary" v-if="hasOk">
          确定
        </Button>
      </div>

      <!--图片预览-->
      <Modal :closable="true" class-name="vertical-center-modal" footer-hide
             title=""
             v-model="previewModal.show"
             width="650">
        <p class="text-center" slot="header">
          <span>{{ previewModal.title }}</span>
        </p>
        <div class="p-h-10 p-b-10 o-y-auto"
             style="min-height: 200px;max-height: 600px">
          <img :onerror="loadImgError"
               :src="previewModal.picUrl?previewModal.picUrl:require('../../../assets/common/ic_wutu@2x.png')"
               style="width: 100%">
        </div>
      </Modal>
    </div>
    <!--    视频预览-->
    <Modal
      @on-visible-change="onVideoPrewModalClose"
      class-name="vertical-center-modal"
      footer-hide
      v-model="showVideoPrew"
      width="650">
      <video-prew :videoinfo="videoprewinfo" ref="prewplayer"/>
    </Modal>

    <!--    商品选择弹框-->
    <Modal :closable="false"
           :mask-closable="false"
           class-name="vertical-center-modal"
           footer-hide
           v-model="showprochoose"
           width="1200">
      <product-choose-widget :open="showprochoose"
                             @cancel="showprochoose=false"
                             @ok="onProductSelected"/>
    </Modal>
  </Modal>
</template>

<script>
import basePageComponent from '@/components/common/BasePageComponent'
import VideoPrew from '@/components/common/VideoPrew'
import {mapActions} from 'vuex'
import {getColumns, getPages} from '@/components/common/chiose/MaterailChoiceWidgetUtil'
import ClassVerticalChooseWidget from '@/components/common/ClassVerticalChooseWidget'
import {getEntNavigations} from '@/services/navigationapi'
import ProductChooseWidget from '@/components/product/ProductChooseWidget'

export default {
  name: 'MaterailChoiceWeidget',
  components: {
    ProductChooseWidget,
    ClassVerticalChooseWidget,
    basePageComponent,
    VideoPrew,
  },
  props: {
    //标题
    title: {
      type: String,
      default: '请选择',
    },
    // 宽度
    width: {
      type: Number,
      default: 1200,
    },
    //有确认按钮
    hasOk: {
      type: Boolean,
      default: true,
    },
    //有取消按钮
    hasCancel: {
      type: Boolean,
      default: true,
    },
    // 点击确认
    onOk: Function,
    // 点击取消
    onCancel: Function,
    //是否多选
    multiple: {
      type: Boolean,
      default: false
    },

    //第一个下拉框供选择的页面
    pages: {
      type: Array,
      default: () => getPages()
    },
    //获取首页数据是否有"我的"页面
    hasMine:{
      type:Boolean,
      default:true,
    }
  },
  data () {
    return {
      searchText: '',
      copyText: '复制内容',
      checkboxStatus: false, //分类分组选择框状态

      // srcType: 11,
      //视频预览
      showVideoPrew: false,
      //商品选择弹框(案例页)
      showprochoose: false,
      videoprewinfo: {       //视频预览参数
        videoAliVid: '',
        videoUrl: '',
        coverUrl: '',
        videoTitle: ''
      },
      //页面类型,只用于区分页面
      selectedPageId: 0,
      //页面type,获取分类分组信息的请求参数
      srcType: 15,
      //没有分类分组时,拼接 链接 使用
      contentType: 0,
      //分类集合
      classList: [],
      //分组集合
      groupList: [],

      selectedObj: {
        //选中的分类
        selectedClass: 0,
        selectedClassUrl: '',
        selectedClassName: '',
        //选中的分组
        selectedGroup: 0,
        selectedGroupUrl: '',
        selectedGroupName: '',
        //(案例库)选中的商品
        selectedProductName: '',
        selectedProduct: 0,
      },


      //素材类型下有分类筛选
      hasClass: true,
      //素材类型下有分组筛选
      hasGroup: true,
      //有搜索框
      canSearch: true,
      //有商品选择框
      hasProductChoose: false,

      maps: new Map(),
      mapLength: 0,

      //数据展示类型: 0-表格 1-图标列表
      dataType: 0,

      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 21, //图片库,一页21个.
      },

      //显示隐藏
      modalShowHide: false,
      //表格标头
      columns: [],
      //表格数据
      dataList: [],
      //
      //图库库图片预览
      previewModal: {
        title: '',
        show: false,
        picUrl: '',
      },
      loadImgError: 'this.src="' + require('../../../assets/common/ic_wutu@2x.png') + '"',
    }
  },
  computed: {
    /**
     * 获取分类分组链接
     */
    getClass2dGroupUrl () {
      let url = ''
      if (this.selectedObj.selectedGroup && this.selectedObj.selectedGroupUrl) {         //分组url
        url = this.selectedObj.selectedGroupUrl
      } else if (this.selectedObj.selectedClass && this.selectedObj.selectedClassUrl) {  //分类url
        url = this.selectedObj.selectedClassUrl
      } else {                                                                           //全选 url
        url = this.getTypeAlltext()
      }
      if (url && this.selectedObj.selectedProduct) {                                     //可能拼接商品id
        url += '&goodsId=' + this.selectedObj.selectedProduct
      }
      return url
    },
    /**
     * 获取分类分组label
     */
    getClass2dGroupLabel () {
      let obj = this.selectedObj
      let name = ''
      if (obj.selectedClass && obj.selectedClassName) {  //有分类
        name += obj.selectedClassName
        if (obj.selectedGroup && obj.selectedGroupName) {  //有分组
          name += ' / ' + obj.selectedGroupName
        }
        if (obj.selectedProduct) { //有产品
          name += ' / ' + obj.selectedProductName
        }
      } else {      //全部分类分组情况,再判断是否选择产品
        if (obj.selectedProduct && obj.selectedProductName) { //有产品
          name = obj.selectedProductName
        } else {        //没产品
          name = '全部'
        }
      }
      return name
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
    },
    /**
     * 分类分组均为全部时,拼接链接
     */
    getTypeAlltext () {
      let str = ''
      switch (parseInt(this.srcType)) {
        case 8:
          str = 'https://goodsmanual.laodao.co/bbs/materialImgCategory.html?id=0&contentType='
          break
        case 6:
          str = 'https://goodsmanual.laodao.co/img/materialImgCategory.html?id=0&contentType='
          break
        case 11:
          str = 'https://goodsmanual.laodao.co/goods/materialImgCategory.html?id=0&contentType='
          break
        case 10:
          str = 'https://goodsmanual.laodao.co/video/materialImgCategory.html?id=0&contentType='
          break
      }
      return str + this.contentType
    },
    ok () {
      if (this.onOk) {
        let data = []
        this.maps.forEach((value, key) => {
          data.push({
            url: value.url || ''
          })
        })
        console.log('material choice ok:', data)
        this.onOk(data)
      }
      this.hide()
    },
    cancel () {
      if (this.onCancel)
        this.onCancel()
      this.hide()
    },
    show () {
      if (this.pages && this.pages.length > 0) {
        let defaultPageId = this.pages[0].id
        this.selectedPageId = defaultPageId
        this.onSelectedPageChange(defaultPageId)
      }
      this.modalShowHide = true
    },
    hide () {
      this.modalShowHide = false
    },

    getTableHeight () {
      if (this.selectedPageId === 9){
        return 500 + 86
      }
      if (this.classList.length === 0) {
        return 500 + 43
      }
      return 500
    },
    getMarginTop () {
      if (this.hasGroup) {
        return 10 + 'px'
      }
      return 0
    },
    preview (row) {
      this.previewModal.title = row.title
      this.previewModal.picUrl = row.imgUrl
      // this.previewModal.picUrl = row.sourceUrl
      this.previewModal.show = true
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    copyOnError (e) {
      this.$Message.info('复制失败')
    },
    onVideoPrewModalClose (status) {
      if (!status) {
        this.videoprewinfo = {
          videoUrl: '',
          videoAliVid: '',
          coverUrl: '',
          videoTitle: ''
        }
      }
    },

    /**
     * tag点击切换页面
     */
    changePage (pageId) {
      this.selectedPageId = pageId
      this.onSelectedPageChange(pageId)
    },

    /**
     * 下拉切换页面, 对应第一个下拉框
     * @param result 页面id
     */
    onSelectedPageChange (result) {
      this.$nextTick(() => {
        //清空分类
        this.classList = []
        //清空分组
        this.groupList = []
        //清空列表数据
        this.dataList = []
        //清空分类分组选择框状态
        this.checkboxStatus = false
        //清空搜索框数据
        this.searchText = ''
        //默认没有 商品选择框
        this.hasProductChoose = false
        //页码归1
        this.tablePage.currentPage = 1
        //清空 已选map
        this.maps = new Map()
        //默认 有搜索输入框
        this.canSearch = true
        let ii = this.pages.findIndex(value => value.id === result)
        this.srcType = this.pages[ii].srcType
        this.contentType = this.pages[ii].contentType || ''
        this.selectedObj = {
          //选中的分类
          selectedClass: 0,
          selectedClassUrl: '',
          selectedClassName: '',
          //选中的分组
          selectedGroup: 0,
          selectedGroupUrl: '',
          selectedGroupName: '',
          //(案例库)选中的商品
          selectedProductName: '',
          selectedProduct: 0,
        }
      })


      //默认0
      this.dataType = 0
      switch (result) {
        case 0:
          // 落地页
          this.hasClass = false
          this.hasGroup = false
          this.columns = getColumns(0)
          this.getMaterialBasePageData()
          break
        case 1:
          // 引导页
          this.hasClass = false
          this.hasGroup = false
          this.columns = getColumns(1)
          this.getMaterialBasePageData()
          break
        case 2:
          // 视频库
          this.hasClass = true
          this.hasGroup = true
          this.columns = getColumns(2)
          let i2 = this.pages.findIndex(value => value.id === result)
          this.$nextTick(() => {
            if (i2 > -1) {
              this.srcType = this.pages[i2].srcType
              this.getClassList()
            }
            this.getVideoListData()
          })
          break
        case 3:
          // 图片库
          this.hasClass = true
          this.hasGroup = true
          this.dataType = 2
          this.columns = getColumns(3)
          let i3 = this.pages.findIndex(value => value.id === result)
          this.$nextTick(() => {
            if (i3 > -1) {
              this.srcType = this.pages[i3].srcType
              this.getClassList()
            }
            this.getPicListData()
          })
          break
        case 5:
          // 案例库
          this.$nextTick(() => {
            this.hasClass = true
            this.hasGroup = true
            this.canSearch = false
            this.hasProductChoose = true
          })

          this.columns = getColumns(5)
          let i5 = this.pages.findIndex(value => value.id === result)
          this.$nextTick(() => {
            if (i5 > -1) {
              this.srcType = this.pages[i5].srcType
              this.getClassList()
            }
            this.getBBsLists()
          })

          break
        case 8:
          this.hasClass = true
          this.hasGroup = true
          this.columns = getColumns(8)
          let index = this.pages.findIndex(value => value.id === result)
          this.$nextTick(() => {
            if (index > -1) {
              this.srcType = this.pages[index].srcType
              this.getClassList()
            }
            this.onGetGoods()
          })
          break
        case 9:
          this.$nextTick(() => {
            this.hasClass = false
            this.hasGroup = false
            this.canSearch = false
            this.columns = getColumns(9)
            this.getEntNavigations()
          })
          break
      }

    },

    /**
     * 分类发生变化
     */
    onSelectedClassChange (result) {

      this.searchText = ''
      this.tablePage.currentPage = 1
      this.maps = new Map()
      this.groupList = []
      this.selectedObj.selectedGroup = 0
      this.selectedObj.selectedGroupName = ''
      this.checkboxStatus = false

      //选中的分类
      let classIndex = this.classList.findIndex(item => item.id === result)
      if (classIndex > -1) {
        let item = this.classList[classIndex]
        this.selectedObj = {
          ...this.selectedObj,
          selectedClass: item.id,
          selectedClassName: item.label,
          selectedClassUrl: item.link,
        }
      } else {      //清空分类
        this.selectedObj = {
          ...this.selectedObj,
          selectedClass: 0,
          selectedClassName: '',
          selectedClassUrl: '',
          selectedGroup: 0,
          selectedGroupName: '',
          selectedGroupUrl: '',
        }
      }

      if (classIndex > -1)
        this.getGroupListDatas()
      this.search()
    },
    /**
     * 分组发生变化
     */
    onSelectedGroupChange (result) {
      this.searchText = ''
      this.tablePage.currentPage = 1
      this.maps = new Map()
      this.selectedObj.selectedGroup = 0
      this.selectedObj.selectedGroupName = ''
      this.checkboxStatus = false

      let selectedGroupIndex = this.groupList.findIndex(item => item.id === result)

      if (selectedGroupIndex > -1) {          //选中分组
        let item = this.groupList[selectedGroupIndex]
        this.selectedObj = {
          ...this.selectedObj,
          selectedGroup: item.id,
          selectedGroupName: item.label,
          selectedGroupUrl: item.link,
        }
      } else {                //清空分组
        this.selectedObj = {
          ...this.selectedObj,
          selectedGroup: 0,
          selectedGroupName: '',
          selectedGroupUrl: '',
        }
      }

      this.search()
    },

    /**
     * 改变分类分组链接选择框状态
     */
    changeCheckBoxStatus () {
      if (!this.selectedObj || !this.getClass2dGroupUrl)
        return
      this.checkboxStatus = !this.checkboxStatus
      this.$nextTick(() => {
        this.checkboxStatusChange(this.checkboxStatus)
      })
    },

    /**
     * 分类分组的checkbox选中状态发生变化
     */
    checkboxStatusChange (status) {
      if (!this.selectedObj || !this.getClass2dGroupUrl) {
        this.$nextTick(() => {
          this.checkboxStatus = false
        })
        return
      }
      this.maps.clear()
      this.mapLength = 0
      if (status) {
        //id 用0..
        this.maps.set(0, {url: this.getClass2dGroupUrl})
        this.mapLength = this.maps.size
      }
    },
    play (item) {
      if (item.sourceUrl || item.videoAliVid) {
        this.videoprewinfo = {
          videoUrl: item.sourceUrl || '',
          videoAliVid: item.videoAliVid || '',
          coverUrl: item.coverImgUrl,
          videoTitle: item.title
        }
        this.showVideoPrew = true
      }
    },

    /**
     * 选中行
     */
    onRowClick (row) {
      this.checkboxStatus = false
      let id = row.id
      if (this.multiple) {
        if (this.maps.has(id)) {
          this.maps.delete(id)
        } else {
          this.maps.set(id, row)
        }
      } else {
        this.maps.clear()
        this.mapLength = 0
        this.maps.set(id, row)
      }
      this.mapLength = this.maps.size
    },

    isSelected (item) {
      let id = item.id
      if (this.mapLength && this.maps.has(id)) {
        return true
      } else {
        return false
      }
    },

    search () {
      switch (this.selectedPageId) {
        case 0:
          this.getMaterialBasePageData()
          break
        case 1:
          this.getMaterialBasePageData()
          break
        case 2:
          this.getVideoListData()
          break
        case 3:
          this.getPicListData()
          break
        case 5:
          this.getBBsLists()
          break
        case 8:
          this.onGetGoods()
          break
        case 9:
          this.getEntNavigations()
          break

      }
    },

    formatSeconds (value) {
      var secondTime = parseInt(value)// 秒
      var minuteTime = 0// 分
      var hourTime = 0// 小时
      if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60)
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60)
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60)
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      var result = '' + parseInt(secondTime) + '秒'

      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result
      }
      if (hourTime > 0) {
        result = '' + parseInt(hourTime) + '小时' + result
      }
      return result
    },

    //分页 页码切换
    onPageChange (page) {
      this.tablePage.currentPage = page
      this.dataList = []
      this.search()
    },

    /**
     * 落地页引导页获取数据
     */
    getMaterialBasePageData () {

      //固定值, 落地页1, 引导页2
      let isSingle = 1
      if (this.selectedPageId === 1) {
        isSingle = 2
      }

      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage,
        isSingle: isSingle,
      }
      if (this.searchText) {
        params.name = this.searchText
      }
      this.getWebPageList(params).then((res) => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(item => {
            return {
              id: item.id,
              name: item.name,
              url: item.link.link,
              createTime: item.createTime,
              status: item.isEnable || 0,
            }
          })
          this.tablePage.total = res.data.total
        } else {
          this.$Message.info(res.msg)
        }
      })
    },

    /**
     * 获取商品信息
     */
    onGetGoods () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.searchText) {
        params.name = this.searchText
      }
      let selectedObj = this.selectedObj
      if (selectedObj && selectedObj.selectedClass > -1) {
        params.categoryId = selectedObj.selectedClass
      }
      if (selectedObj && selectedObj.selectedGroup > -1) {
        params.groupId = selectedObj.selectedGroup
      }

      this.getGoods(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            child.url = child.link ? child.link.link || '' : ''
            child.status = child.isEnable || 0
            return child
          })
          this.tablePage.total = res.data.total || 0
        }
      })
    },

    /**
     * 获取图片列表数据
     */
    getPicListData () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.searchText) {
        params.title = this.searchText
      }
      let selectedObj = this.selectedObj
      if (selectedObj && selectedObj.selectedClass > -1) {
        params.categoryId = selectedObj.selectedClass
      }
      if (selectedObj && selectedObj.selectedGroup > -1) {
        params.groupId = selectedObj.selectedGroup
      }
      this.getPicLists(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            //图片key:imgUrl, 链接key:url
            child.imgUrl = child.url
            child.url = child.jumpLink ? child.jumpLink.link || '' : ''
            child.id = child.imgId || ''
            return child
          })
          this.tablePage.total = res.data.total
        }
      })
    },

    /**
     * 获取视频列表数据
     */
    getVideoListData () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.searchText) {
        params.title = this.searchText
      }
      let selectedObj = this.selectedObj
      if (selectedObj && selectedObj.selectedClass > -1) {
        params.categoryId = selectedObj.selectedClass
      }
      if (selectedObj && selectedObj.selectedGroup > -1) {
        params.groupId = selectedObj.selectedGroup
      }
      this.getVideoList(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            child.createTime = child.createTime ? new Date(child.createTime).format('yyyy-MM-dd') : ''
            child.videoLength = this.formatSeconds(child.videoLength)

            child.url = child.jumpLink ? child.jumpLink.link || '' : ''
            child.id = child.videoId
            return child
          })
          this.tablePage.total = res.data.total
        }
      })
    },

    /**
     * 获取案例 动态列表
     * */
    getBBsLists () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      // if (this.searchText) {
      //   params.title = this.searchText
      // }
      let selectedObj = this.selectedObj
      if (selectedObj && selectedObj.selectedClass > -1) {
        params.categoryId = selectedObj.selectedClass
      }
      if (selectedObj && selectedObj.selectedGroup > -1) {
        params.groupId = selectedObj.selectedGroup
      }
      if (selectedObj && selectedObj.selectedProduct) {
        params.goodsId = selectedObj.selectedProduct
      }
      this.getbbslist(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            child.username = child.user ? child.user.name || '' : ''
            child.url = child.link ? child.link.link || '' : ''
            return child
          })
          this.tablePage.total = res.data.total || 0
        }
      })

    },

    //案例商品弹框点击确认
    onProductSelected (list) {
      if (list && list.length) {
        this.selectedObj.selectedProductName = list[0].name || ''
        this.selectedObj.selectedProduct = list[0].id || 0
      } else {
        this.selectedObj.selectedProductName = ''
        this.selectedObj.selectedProductId = 0
      }
      this.showprochoose = false
      this.onProductSelectedChange()
    },

    //案例选择框数据发生变化
    onProductSelectedChange () {
      let name = this.selectedObj.selectedProductName
      if (!name) { //点击clear name会清空,id也要清空
        this.selectedObj.selectedProduct = 0
      }
      this.getBBsLists()
    },

    //获取首页数据
    getEntNavigations () {
      return new Promise((resolve, reject) => {
        getEntNavigations().then(res => {
          this.dataList = res.data.buttonList.filter(res => {
            if (this.hasMine){
              return res.type === 1 || res.type === 2 || res.type === 3 || res.type === 4 || res.type === 5
            }else{
              return res.type === 1 || res.type === 2 || res.type === 3 || res.type === 4
            }
          }).map(child => {
            child.hasRenovation = 1
            child.loadOtherUrl = ''
            return {
              id: child.id,
              label: child.name,
              name: child.name,
              url: child.link ? child.link.link : '',
              updateTime:child.updateTime,
              status: child.isEnable || 0,
            }
          })
        })
      })
    },

    //获取分类集合
    async getClassList () {
      this.classList = await new Promise((resolve, reject) => {
        let params = {
          type: this.srcType,
        }
        this.getCategoryLists(params).then((res) => {
          if (res.code === 0) {
            let arr = res.data
            let array = []
            if (arr) {
              arr.forEach(item => {
                array.push({
                  id: item.id,
                  label: item.name,
                  link: item.link ? item.link.link : ''
                })
              })
            }
            resolve(array)
          }
        })
      })
    },
    //获取分组集合
    async getGroupListDatas () {
      let params = {
        categoryId: this.selectedObj.selectedClass,
        type: this.srcType
      }
      this.groupList = await new Promise((resolve, reject) => {

        this.getGroupLists(params).then(res => {
          let respArr = res.data
          let arr = []
          if (respArr) {
            respArr.forEach(item => {
              arr.push({
                id: item.id,
                label: item.name,
                link: item.link ? item.link.link : ''
              })
            })
          }
          resolve(arr)
        })
      })
    },

    ...mapActions([
      'getWebPageList',
      'getGoods',
      'getPicLists',
      'getVideoList',
      'getCategoryLists',
      'getGroupLists',
      'getbbslist',
    ])
  }
}
</script>

<style lang="scss" scoped>
.modal-setting ::v-deep {

  .ivu-modal-header-inner {
    display: flex;
    justify-content: center;
    font-weight: bold;
  }

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}

.lin1 {
  color: #333;
  max-width: 600px;
  font-size: 13px;
  text-overflow: ellipsis;
  overflow: hidden; /** 隐藏超出的内容 **/
  white-space: nowrap; /*强制span不换行*/
  width: 260px; /*限制宽度*/
  overflow: hidden; /*超出宽度部分隐藏*/
  text-overflow: ellipsis; /*超出部分以点号代替*/
}

.list-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow-x: hidden;
}

.item {
  width: 140px;
  height: 170px;
  flex-direction: row;
  margin-bottom: 10px;
}

.item-selected {
  //border-color: #0EA4FB;
  //border-width: 2px;
  border: 2px solid #0EA4FB;
}

.item-normal {
  //border-color: #0EA4FB;
  //border-width: 2px;
  border: 2px solid white;
}

.item-editable {
  display: none;
}

.item:hover .item-editable {
  display: flex;
}

.triangle {
  width: 0;
  height: 0;
  border-color: transparent #0F8CFB;
  border-width: 0 25px 25px 0;
  border-style: solid;
}


</style>
